import { memo } from 'react';
import {
  StatusDisplay,
  type StatusProps,
} from 'src/components/data-display/status-display';
import { labelsToOptions } from 'src/utils/labels-to-options';
import { labelsToValues } from 'src/utils/labels-to-values';

export type DocumentStatus = 'WITHDRAWN' | 'PUBLISHED';

export const documentStatusLabels: Record<DocumentStatus, string> = {
  WITHDRAWN: 'Withdrawn',
  PUBLISHED: 'Published',
};

type Props = {
  value: DocumentStatus;
  'data-testid'?: string;
};

export const documentStatusOptions = labelsToOptions(documentStatusLabels);

export const documentStatusValues = labelsToValues(documentStatusLabels);

const variantMap: Record<DocumentStatus, StatusProps['variant']> = {
  WITHDRAWN: 'inactive',
  PUBLISHED: 'success',
};

export const ShipperDocumentStatusDisplay = memo<Props>(
  ({ value, 'data-testid': testId }) => {
    return (
      <StatusDisplay
        status={documentStatusLabels[value]}
        variant={variantMap[value]}
        data-testid={testId}
      />
    );
  }
);
